import { useTranslation } from 'react-i18next';

import {
    Heading1,
    Stack,
    Subtitle2,
} from '@myphx-engineering/phx-design-system';

import { getFragment } from '../../graphql';
import type { PriorAuthorizationInfoFragment } from '../../graphql/generated/graphql';

import { MissingBenefitsCard } from './components/MissingBenefitsCard';
import { PriorAuthLastActivityCard } from './components/PriorAuthLastActivityCard';

type PriorAuthorizationDetailsProps = {
    priorAuthorization: PriorAuthorizationInfoFragment;
};

export const PriorAuthorizationDetails = ({
    priorAuthorization,
}: PriorAuthorizationDetailsProps) => {
    const { t } = useTranslation();

    const patient = getFragment(priorAuthorization.patient);
    const medication = getFragment(priorAuthorization.medication);

    return (
        <Stack gap="lg">
            <Stack gap="xs">
                <Subtitle2>
                    {t('priorAuth.paForUser.header', {
                        patientName: patient.fullName,
                    })}
                </Subtitle2>
                <Heading1>{medication.name}</Heading1>
            </Stack>

            <MissingBenefitsCard />
            <PriorAuthLastActivityCard
                priorAuthorization={priorAuthorization}
            />
        </Stack>
    );
};
